import HttpRequestRotoBrain from "../../Services/HttpRequestRotoBrain";

export const chatBotLikesUnlikes = async (body:any) => {
    try {
      const response = await HttpRequestRotoBrain({
        method: "POST",
        url: `v1/chat/like-message`,
        data : body,
      });
  
      return {
        data: response.data,
        status: response.status,
      };
    } catch (error) {
      return {
        status: false,
        errors: error,
      };
    }
  };
  

  export const getChatBotConversationHistory = async () => {
    try {
      const response = await HttpRequestRotoBrain({
        method: "GET",
        url: `v1/chat/conversations`,
      });
  
      return {
        data: response.data,
        status: response.status,
      };
    } catch (error) {
      return {
        status: false,
        errors: error,
      };
    }
  };
  
  export const getChatBotConversationHistoryById = async (thread_id:string|null) => {
    try {
      const response = await HttpRequestRotoBrain({
        method: "GET",
        url: `v1/chat/conversation/${thread_id}`,
      });
  
      return {
        data: response.data,
        status: response.status,
      };
    } catch (error) {
      return {
        status: false,
        errors: error,
      };
    }
  };